import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-db-error-component",
	templateUrl: "./db-error-component.html",
	standalone: false,
})
export class DbErrorComponent {
	constructor() {}
}
